import React, { useMemo } from "react"
import CallSheetFormSection from "./CallSheetFormSection"
import { useConfigFlag } from "@cloudbreakus/featurebang-react"
import { generateValidationFunction } from "../utils"
import WrappedInput from "./WrappedInput"
import CallDetailsSection from "./CallDetailsSection"

const ValidatedInput = ({ configKey, ...rest }) => {
  const length = useConfigFlag(`callsheet.constraints.${configKey}.length`)
  const validationFunctions = useMemo(() => {
    return generateValidationFunction({
      length,
    })
  }, [length])

  return <WrappedInput {...rest} maxLength={length} validation={validationFunctions} />
}

const CallSheet = ({
  className,
  interactionId,
  language,
  partnerName,
  unitId,
  partnerLocationId,
  partnerLocations,
  department,
  departmentName,
  patientFirstName,
  patientLastName,
  patientMRN,
  patientDOB,
  providerFirstName,
  providerLastName,
  nonBillableReasons,
  departmentOptions,
  showCollectDepartment,
  onPatientDOB,
  onNonBillableReasons,
  onPartnerLocation,
  onDepartment,
  onPatientFirstName,
  onPatientLastName,
  onPatientMRN,
  onProviderFirstName,
  onProviderLastName,
  showPatientFirstName,
  showPatientLastName,
  showPatientMRN,
  showPatientDOB,
  showProviderFirstName,
  showProviderLastName,
  customerPhoneNumber,
  exitConfirmation,
  ExtraFields,
}) => {
  const _onPartnerLocation = (...args) => {
    onDepartment("")
    onPartnerLocation(...args)
  }
  return (
    <div className={className}>
      <CallDetailsSection
        interactionId={interactionId}
        language={language}
        partnerName={partnerName}
        unitId={unitId}
        partnerLocationId={partnerLocationId}
        partnerLocations={partnerLocations}
        department={department}
        departmentName={departmentName}
        nonBillableReasons={nonBillableReasons}
        departmentOptions={departmentOptions}
        showCollectDepartment={showCollectDepartment}
        onNonBillableReasons={onNonBillableReasons}
        onPartnerLocation={_onPartnerLocation}
        onDepartment={onDepartment}
        customerPhoneNumber={customerPhoneNumber}
        exitConfirmation={exitConfirmation}
        wizardStatus="complete"
        showIntakeForm
      />
      <CallSheetFormSection
        title={"Patient"}
        className={{ hidden: !(showPatientFirstName || showPatientLastName || showPatientMRN || showPatientDOB) }}
      >
        {showPatientFirstName && (
          <ValidatedInput
            name="patient-first-name"
            label="Patient First Name *"
            value={patientFirstName}
            disabled={exitConfirmation}
            onChange={onPatientFirstName}
            configKey="patientFirstName"
          />
        )}
        {showPatientLastName && (
          <ValidatedInput
            name="patient-last-name"
            label="Patient Last Name *"
            value={patientLastName}
            onChange={onPatientLastName}
            disabled={exitConfirmation}
            configKey="patientLastName"
          />
        )}
        {showPatientMRN && (
          <ValidatedInput
            name="patient-mrn"
            label="Patient MRN *"
            value={patientMRN}
            onChange={onPatientMRN}
            disabled={exitConfirmation}
            configKey="patientMRN"
          />
        )}
        {showPatientDOB && (
          <ValidatedInput
            name="patient-dob"
            label="Patient DOB *"
            value={patientDOB}
            onChange={onPatientDOB}
            type={"calendar"}
            disabled={exitConfirmation}
            configKey="patientDOB"
          />
        )}
      </CallSheetFormSection>
      <CallSheetFormSection title={"Provider"} className={{ hidden: !(showProviderFirstName || showProviderLastName) }}>
        {showProviderFirstName && (
          <ValidatedInput
            name="provider-first-name"
            label="Provider First Name *"
            value={providerFirstName}
            onChange={onProviderFirstName}
            disabled={exitConfirmation}
            configKey="providerFirstName"
          />
        )}
        {showProviderLastName && (
          <ValidatedInput
            name="provider-last-name"
            label="Provider Last Name *"
            value={providerLastName}
            onChange={onProviderLastName}
            disabled={exitConfirmation}
            configKey="providerLastName"
          />
        )}
      </CallSheetFormSection>
      <ExtraFields />
    </div>
  )
}

export default CallSheet
